import React from 'react';

import {
  Button,
  Card,
  Message,
  useNavigation,
  useTranslation,
} from '@helios/frontend-core';

import { openHome } from '../../components/IntercomBubble/IntercomBubble';

import Page from '../../components/Page/Page';
import { PlatformConfig } from '../../config';
import { PHONE_SUPPORT, formatPhone } from '../../utils/contact';

import styles from './PageError.module.scss';

export interface Props {
  error: Error;
}

const PageError: React.FC<Props> = (props: Props) => {
  const { error } = props;
  const [clicks, setClicks] = React.useState<number>(0);
  const { goBack } = useNavigation();
  const { t } = useTranslation();
  const localePrefix = 'pageError';
  const showError = clicks >= 3;
  return (
    <Page layout="singleItem">
      <Card maxWidth="4xl" padding="lg" className={styles.pageError}>
        <Button
          emphasis="tertiary"
          className={styles.clickable}
          onClick={() => setClicks(clicks + 1)}
          trackingId="page-error-debugger"
        >
          <div>
            <h1>{t(`${localePrefix}.error`)}</h1>
            <p>{t(`${localePrefix}.errorMessage`)}</p>
          </div>
        </Button>
        <div>
          <Button emphasis="tertiary" className={styles.button} onClick={goBack} trackingId="page-error-back">
            {t('common.goBack')}
          </Button>
          <Button
            className={styles.button}
            onClick={() => {
              window.location.reload();
            }}
            trackingId="page-error-reload"
          >
            {t(`${localePrefix}.reload`)}
          </Button>
        </div>

        <div className={styles.support}>
          <button onClick={openHome} className="text-link hover:text-link-hover underline cursor-pointer">
            {t(`${localePrefix}.connectWithCustomerSupport`)}
          </button>
          <div className={styles.call}>
            {t(`${localePrefix}.callUs`)} <a href={`tel:+${PHONE_SUPPORT}`}>{formatPhone(PHONE_SUPPORT)}</a>
          </div>
        </div>
        {showError && (
          <Message className={styles.error} color="red" title={error.message}>
            {PlatformConfig.isTestRun || PlatformConfig.isStorybook ? `${error.message} stack trace` : error.stack}
          </Message>
        )}
      </Card>
    </Page>
  );
};

export default PageError;
